import {h, Component} from 'preact';

import {observer} from "mobx-preact";

@observer
class Layout extends Component {
    render() {
        return <div className="kol-layout" id="kol-layout">
            <div className="kol-layout__placeholder">
            {this.props.children}
            </div>
        </div>
    }
}

export default Layout;
